import React, { useEffect, useState } from 'react'
import Layout from '../../../components/Layout/Layout'
import { Link } from 'react-router-dom'
import axios from 'axios'
import { toast } from 'react-toastify'

const AdminTeamBookSaleList = () => {
  const [groups, setGroups] = useState([])
  const [resetting, setResetting] = useState(false)

  useEffect(() => {
    const fetchGroups = async () => {
      try {
        const { data } = await axios.get('/api/v1/admin/summary/groups')
        if (data.success) {
          setGroups(data.data)
        }
      } catch (error) {
        console.error('Failed to fetch groups:', error.message)
      }
    }

    fetchGroups()
  }, [])

  const handleResetSalesRecords = async () => {
    const confirmReset = window.confirm('Confirm reset Team Book Sale Records?')
    if (!confirmReset) return

    try {
      setResetting(true)
      const { data } = await axios.delete(
        '/api/v1/admin/summary/reset-book-sale',
        {
          withCredentials: true,
        }
      )

      if (data.success) {
        toast.success('Reset successful')
      } else {
        toast.error(data.message || 'Reset failed')
      }
    } catch (err) {
      toast.error(err.response?.data || err.message)
    } finally {
      setResetting(false)
    }
  }

  return (
    <Layout title={'Team Book Sale Records'}>
      <div className='pt-3 mx-3'>
        <div className='d-flex justify-content-between align-items-center'>
          <h5 className='mb-0'>Team Book Sale Records</h5>

          <button
            type='button'
            className='btn btn-danger btn-sm'
            onClick={handleResetSalesRecords}
            disabled={resetting}
          >
            <i className='bi bi-exclamation-triangle-fill me-2'></i>
            {resetting ? 'Resetting...' : 'Reset Data'}
          </button>
        </div>

        <div className='row'>
          {groups.map((group) => (
            <div
              key={group._id}
              className='col-12 col-md-4 mt-2 mb-2 gx-3 gy-3'
            >
              <div className='card'>
                <Link
                  to={`/admin/team-book-sale/${group._id}`}
                  className='btn btn-outline-success'
                  style={{ fontSize: '20px' }}
                >
                  {group.groupName}
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  )
}

export default AdminTeamBookSaleList
